import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageHeaderWithSearchBar from '@/components/common/Header/PageHeaderWithSearchBar.vue'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import OrgmapContainer from '../containers/OrgmapContainer.vue'
import UserDetail from '../components/Orgmap/UserDetail.vue'
@Component({
    components: { 
        PageHeaderWithSearchBar, 
        PageViewHeaderWithActionBar,
        OrgmapContainer, 
        UserDetail 
    }
})
export default class OrgmapView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    detailViewMode: boolean = false

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    detailViewModeChange(flag: boolean) {
        this.detailViewMode = flag
    }
}
